<template>
  <div id="app">
    <loading ref="loading" />
    <modal-counting></modal-counting>
    <component :is="layout" v-if="layout" />
  </div>
</template>

<script>
import Loading from "./components/commons/Loading";
import ModalCounting from './components/commons/ModalCounting.vue';
export default {
  el: "#app",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Loading,
    ModalCounting
  },
  computed: {
    /**
     * Set the application layout.
     */
    layout() {
      return this.$route.meta.layout || this.GuestLayout;
    }
  },
  data: function() {
    return {
      toast_counter: 0
    };
  },
  methods: {
    showToast(title, msg, variant = "success", append = false) {
      this.toast_counter++;
      this.$bvToast.toast(msg, {
        title: title,
        toaster: "b-toaster-top-center",
        solid: true,
        appendToast: append,
        variant: variant
      });
    }
  },
  mounted() {
    this.$loading = this.$refs.loading;
  }
};
</script>

<style lang="scss">
@import "./styles/main";
</style>
